import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { Observable } from "rxjs";
import { HttpClient, HttpParams, HttpRequest, HttpEvent } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/auth';
import { finalize } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TranslateCompiler, TranslateService } from '@ngx-translate/core';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-relationshipschoolusers',
  templateUrl: './relationshipschoolusers.component.html',
  styleUrls: ['./relationshipschoolusers.component.sass']
})
export class RelationshipschoolusersComponent implements OnInit {
  relationshipsListSubs: Subscription;
  relationships: any;
  relationshipsList: Relationship[];
  relationshipForm: FormGroup;
  isList: boolean = true;
  isNew: boolean = false;
  usersListSubs: Subscription;
  users: any;
  stagesListSubs: Subscription;
  stages: any;
  gradesListSubs: Subscription;
  grades: any;
  // linesListSubs: Subscription;
  // lines: any;
  studentsListSubs: Subscription;
  students: any;
  modification_date: string;
  creation_date: string;
  relationship_name: string;
  type_accept: string;
  selectedFiles: File;

  displayedColumns: string[] = ['name', 'actions'];

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;

  showRelationshipsProgressBar: boolean = true;

  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public firebase: AngularFireAuth,
    private http: HttpClient,
    private translate: TranslateService,
    private snackbar: MatSnackBar
  ) { }


  public getUsers() {
    var params = {};
    params['page'] = 1
    params['size'] = 100000
    params['search'] = ''
    params['role'] = 'school';
    this.usersListSubs = this.dataService
      .getUsers(params)
      .subscribe(res => {
        
        this.users = res;
        // this.relationshipForm.controls["users"].setValue(res['items'][0]['id'])
        // this.getStages(res['items'][0]['id'])
      },
        console.error
      );
  }

  // public getStages(schoolID: string) {
  //   this.relationshipForm.controls["stages"].setValue('')
  //   this.relationshipForm.controls["grades"].setValue('')
  //   // this.relationshipForm.controls["lines"].setValue('')
  //   this.relationshipForm.controls["num_list"].setValue('')


  //   this.stagesListSubs = this.dataService
  //     .getStages(schoolID)
  //     .subscribe(res => {
  //       this.stages = res;
  //       // this.relationshipForm.controls["stages"].setValue(res[0]['id'])
  //       // this.getGrades(res[0]['id'])
  //     },
  //       console.error
  //     );
  // }

  // public getGrades(stageID: string) {
  //   this.relationshipForm.controls["grades"].setValue('')
  //   // this.relationshipForm.controls["lines"].setValue('')
  //   this.relationshipForm.controls["num_list"].setValue('')

  //   var params = {}
  //   params['school_id'] = ''
  //   params['stage_id'] = stageID
  //   this.gradesListSubs = this.dataService
  //     .getGrades(params)
  //     .subscribe(res => {
  //       this.grades = res;
  //       // this.relationshipForm.controls["grades"].setValue(res[0]['id'])
  //       // this.getStudents(res[0]['id'])

  //     },
  //       console.error
  //     );
  // }

  // public getLines(gradeID: string) {
  //   // this.relationshipForm.controls["lines"].setValue('')
  //   this.relationshipForm.controls["num_list"].setValue('')

  //   var params = {}
  //   params['school_id'] = ''
  //   params['grade_id'] = gradeID
  //   this.linesListSubs = this.dataService
  //     .getLines(params)
  //     .subscribe(res => {
  //       this.lines = res;
  //       this.relationshipForm.controls["lines"].setValue(res[0]['id'])
  //       this.getStudents(res[0]['id'])

  //       },
  //       console.error
  //     );
  // }

  // public getStudents(gradeId: string) {

  //   var params = {}
  //   params['school_id'] = ''
  //   params['grade_id'] = gradeId
  //   params['size'] = 1000
  //   params['page'] = 1
  //   this.studentsListSubs = this.dataService
  //     .getStudentphotos(params)
  //     .subscribe(res => {
  //       this.students = res;
  //       
  //       //this.relationshipForm.controls["num_list"].setValue(res[0]['id'])

  //     },
  //       console.error
  //     );
  // }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.type_accept = '.pdf';
    this.relationshipForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      users: new FormControl('', Validators.required),
    });

    // this.relationships = this.getRelationships();

    this.route.params.subscribe(params => {

      // if (params.id == 'new') this.showRelationshipsProgressBar = false

      if ((params.user_id) && (params.relationship_id)) {
        this.isList = false;
        this.getUsers()


        // this.getSchools();
        if (params.relationship_id != 'new') {
          this.isNew = false;
          this.relationshipsListSubs = this.dataService
            .getRelationshipSchoolUser(params.relationship_id) //cambiar por id en el html
            .subscribe(res => {
              this.relationships = res;
              this.relationshipForm.controls["id"].setValue(this.relationships.id);
              this.relationshipForm.controls["users"].setValue(this.relationships.user_id);
              // this.getStages(this.relationships.school_id)
              // this.getGrades(this.relationships.stage_id)
              // this.getStudents(this.relationships.grade_id)
              // this.getStudents(this.relationships.grade_id)
              // this.relationshipForm.controls["stages"].setValue(this.relationships.stage_id);
              // this.relationshipForm.controls["grades"].setValue(this.relationships.grade_id);

              // this.relationshipForm.controls["num_list"].setValue(this.relationships.student_id);
              // this.value = `${environment.WEB_URL}/public/` + this.relationships.id;
              this.modification_date = this.relationships.modification_date;
              this.creation_date = this.relationships.creation_date;
              this.relationship_name = this.relationships.name;
            },
              console.error
            );
        }
        else {
          this.isNew = true;
        }
        // TODO meter else para visualizar relationshipo.
      }
      else {
        this.isList = true;
        if (params.id != 'new') {

          this.dataService.getRelationshipSchoolUsers(params.id, 'school').subscribe(relationships => {
            this.relationships = relationships;
            this.dataSource.data = this.relationships;
            this.showRelationshipsProgressBar = false;
          });
        }
      }
    });
  }


  goTo(relationshipID: string) {
    this.route.params.subscribe(params => {
      this.router.navigateByUrl(params.id + `/relationshipschoolusers/` + relationshipID);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  goBack() {
    this.route.params.subscribe(params => {
      this.router.navigateByUrl('school/' + params.user_id);
    });
  }

  newRelationship() {
    this.route.params.subscribe(params => {
      this.router.navigateByUrl(params.id + `/relationshipschoolusers/new`);
    });
  }


  saveRelationship(file: any) {
    this.route.params.subscribe(url_params => {
      var params = {};
      params['id'] = this.relationshipForm.controls["id"].value;
      params['user_id'] = this.relationshipForm.controls["users"].value;
      params['school_id'] = url_params.user_id;

      if (params['user_id'] == '') {
        this.translate.get('alerts.user_required').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        })
        return false;
      }

      this.dataService.saveRelationshipUserSchools(params).subscribe(data => {
        if (data == '') {
          this.goBack()
        }
        else {
          this.translate.get('alerts.save_rel_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })
    })
  }

  delete(id_relationship: string) {
    this.route.params.subscribe(url_params => {
      var params = {};
      params['id'] = id_relationship;

      this.dataService.deleteRelationshipUserSchools(params).subscribe(data => {
        if (data == 'Relationship deleted') {
          this.translate.get('alerts.rel_deleted').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
          })
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.router.navigate(['/school/' + url_params.id]));
          // this.router.navigateByUrl(`school/` + params['school']);
        }
        else {
          this.translate.get('alerts.rel_deleted_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })
    });
  }

  sendReport(id_relationship: string) {

    this.dataService.getSchoolReport('', id_relationship).subscribe(data => {
      if (data.status == 'success') {
        this.translate.get('alerts.report_send').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
        })
      }
      else if(data.msg && data.msg.includes('email')) {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.email_format'), duration: 4000, panelClass: "error-snackbar"  })
      }
      else {
        this.translate.get('alerts.error').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        })
      }
    })

  }

  // changeFormat() {
  //   if (this.relationshipForm.controls["type"].value == 'pdf') {
  //     this.type_accept = '.pdf';
  //   }
  //   else if (this.relationshipForm.controls["type"].value == 'img') {
  //     this.type_accept = '.jpeg, .png, .jpg, .svg';
  //   }
  //   else {
  //     this.type_accept = '.mp4, .avi, .flv, .mov, .wmv, .divx';
  //   }

  // }
}



export class Relationship {
  constructor(
    public name: string,
    public type: string,
    public id: number,
    public school: string

  ) { }
}